"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const links = [
  { href: "/", label: "home" },
  { href: "/about", label: "about" },
  { href: "/articles", label: "articles" },
  { href: "/projects", label: "projects" },
  { href: "/contact", label: "contact" },
] as const;

function isActive(pathname: string, href: string) {
  if (href === "/") {
    return pathname === "/";
  }

  return pathname === href || pathname.startsWith(`${href}/`);
}

export function Nav() {
  const pathname = usePathname();

  return (
    <nav aria-label="Primary">
      <ul className="flex items-center gap-4 sm:gap-7">
        {links.map(({ href, label }) => {
          const active = isActive(pathname, href);

          return (
            <li key={href}>
              <Link
                href={href}
                className={`group relative pb-2 text-sm tracking-wide transition-colors ${
                  active ? "text-accent" : "text-label hover:text-accent"
                }`}
              >
                <span
                  aria-hidden
                  className={`absolute inset-x-0 bottom-0 h-px bg-accent motion-safe:duration-150 motion-safe:ease-out motion-safe:transition-transform ${
                    active
                      ? "scale-x-100"
                      : "origin-right scale-x-0 group-hover:origin-left group-hover:scale-x-100"
                  }`}
                />
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
